import React from "react"
import { baseRoutes } from "routes"

import { NAVIGATION_LINKS } from "components/navigation/header/meta"
import { SupportPhoneLink } from "components/support-links"
import { Paragraph } from "components/text"

import { DropdownMenu } from "./styles"

const LinksDropdownMenu: React.FC<{ handleClose: () => void }> = ({ handleClose }) => (
  <DropdownMenu.Container>
    <DropdownMenu.List>
      {NAVIGATION_LINKS.map(({ id, title, to }) => (
        <DropdownMenu.Item key={id}>
          <DropdownMenu.Link to={to} onClick={handleClose}>
            {title}
          </DropdownMenu.Link>
        </DropdownMenu.Item>
      ))}
      <DropdownMenu.Item>
        <DropdownMenu.Link to={baseRoutes.signIn()}>Sign In</DropdownMenu.Link>
      </DropdownMenu.Item>
      <DropdownMenu.List>
        <Paragraph mt={4} bold>
          Need help?
        </Paragraph>
        <Paragraph>
          <SupportPhoneLink />
        </Paragraph>
      </DropdownMenu.List>
    </DropdownMenu.List>
  </DropdownMenu.Container>
)

export default LinksDropdownMenu
